var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-toast",style:({ bottom: (_vm.toastPosition + "px") })},[_c('i',{staticClass:"ydr-check-mark"}),_vm._v("\n    "+_vm._s(_vm.$t("copyAltTextCopiedMobile", { word: _vm.getCopiedSynonym.slug }))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eed3ad50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyToast/CopyToast.vue
// module id = null
// module chunks = 